export enum NotificationType {
  NOTICE = "notice",
  SNS = "sns",
}
